import { createContext, useContext } from 'react';
import type { WidgetSettings } from '../../../store/dashboardStore';

/**
 * 위젯 «껍데기» 값 — 배치가 정하고 카드가 그린다 (2026-09-08 · 시안 화면 C).
 *
 * ★★★ 위젯 13종의 코드를 하나도 안 고치려고 **context 로 내려보낸다.** 이 값들은 위젯이 아니라
 *     «그 자리에 놓인 위젯»의 것이라(같은 위젯을 두 자리에 놓으면 이름이 달라질 수 있다)
 *     위젯 컴포넌트가 props 로 받을 일이 아니다. 도구 아이콘을 카드 위에 겹쳐 얹은 것과 같은 결.
 */
export type WidgetHeight = 's' | 'm' | 'l';

export interface WidgetChrome {
  /** 사용자가 고친 표시 이름. 없으면 위젯이 제 이름을 쓴다. */
  title?: string;
  /** 제목을 보일지. 그림이 주인공인 위젯은 숨겨서 통으로 쓴다. */
  showTitle: boolean;
  height: WidgetHeight;
  /**
   * 그 자리에 저장된 **위젯 고유 설정** (2026-09-09 · 판 5).
   *
   * ★★★ 판 5 의 위젯 셋은 **사용자가 정해 주기 전에는 보여 줄 것이 없다** — 포토월은 어느
   *     폴더인지, 빠른 실행은 어느 바로가기인지, 회의실 현황은 어느 분류인지. 그 값들은
   *     이름·높이와 똑같이 «그 자리»의 것이라 여기로 함께 내려보낸다(위젯이 store 를 모른다).
   * ★ 없으면 빈 객체다 — 옛 저장본도 그대로 읽힌다.
   */
  settings: WidgetSettings;
  /**
   * 이 자리의 「위젯 설정」 창을 연다 (2026-09-09 · 판 5).
   *
   * ★★★ 「빠른 실행」의 **「추가」 타일**이 이것을 부른다. 없으면 그 타일은 **눌러도 아무 일이
   *     없는 단추**가 된다 — 그런 것은 만들지 않는다(판 2 의 규칙). 그래서 못 고치는 자리
   *     (잠긴 전사 보드)에서는 값이 **없고**, 위젯이 그 타일을 아예 안 그린다.
   */
  openSettings?: () => void;
}

export const DEFAULT_CHROME: WidgetChrome = { showTitle: true, height: 'm', settings: {} };

export const WidgetChromeContext = createContext<WidgetChrome>(DEFAULT_CHROME);

export function useWidgetChrome(): WidgetChrome {
  return useContext(WidgetChromeContext);
}
